export const Divider = () => {
  return <div className="border-l border-border-medium flex" />;
};
